<template>
  <div id="app">
      <router-view/>     <!--:key="key"-->
  </div>
</template>

<style>

</style>

<script>
    export default {
        computed: {
            /*key() {
                return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
            }*/
        },
    }
</script>
